define('SitecoreFormsExtension/SitecoreFormsExtension',[
    "common/spinner"
],
    function (spinner) {

        function init() {
            // fetch all Sitecore Forms on the page and initialize our custom functionality for it
            $("[action^='/formbuilder?']").each(function () {
                var formId = $(this).attr("id");
                // add spinner to the end of the form
                var spinnerId = "spinner_" + formId;
                $(this).append(spinner.getSpinnerHtml(spinnerId));
                // add custom code to form submit event
                $(this).on("submit", function () {
                    // handling the submit button and the spinner
                    var formSubmitButton = $(this).find(':submit');
                    if (formSubmitButton.length) {
                        var isValidForm = $(this).validate().checkForm();
                        if (isValidForm) {
                            // if the form is valid disable submit button (to prevent multiple clicks on it) and show spinner
                            formSubmitButton.attr('disabled', 'disabled');
                            spinner.show("#" + spinnerId);
                        }
                    }
                });
            });
        }

        return {
            init: init
        };
    }
);

